module.exports = __webpack_public_path__ + "media/images/locations/germany-e5943715bffe8ba21ceb60ba653562d6.jpg";